// axios
import axios from 'axios'

const baseURL = "https://wpapi.worldpos.com.my/qa"
//const baseURL = "http://localhost:5002"

export default axios.create({
  baseURL: baseURL
  // You can add your headers here
})
